// Termos especializados para melhorar reconhecimento de palavras
export const SONIOX_TERMS = [
  // Medicamentos Antiparasitários
  "Simparic", "Revolution", "Bravecto", "Frontline", "NexGard", "Advantage", "Capstar", "Credeli", "Stronghold", "Fipronil", "Ivermectina", "Afoxolaner", "Fluralaner", "Lotilaner", "Sarolaner", "Imidacloprida", "Nitempiran", "Dinotefurano",
  // Vermífugos
  "Drontal", "Milbemax", "Interceptor", "Vermivet", "Mebendazole",
  // Antibióticos
  "Agemoxi CL", "Doxiciclina", "Doxitrat", "Doxifin", "Duotrill", "Dermotrat",
  // Anti-inflamatórios e Analgésicos
  "Librela", "Solensia", "Previcox", "Rymadyl", "Onsior", "Metacam", "Maxicam", "Apoquel", "Dipirona",
  // Medicamentos Neurológicos
  "Fenobarbital", "Diazepam", "Atopica",
  // Cardiológicos e Diuréticos
  "Furosemida", "Furolisin", "Pimobendano", "Amlodipina", "Fortekor", "Benazepril",
  // Digestivos
  "Omeprazol", "Gaviz V", "Cerenia", "Palladia", "Vetoryl",
  // Suplementos e Vitaminas
  "Tiamina", "Hepvet", "Nuxcell",
  // Higiene e Tópicos
  "Otoclean", "Vetriderm",
  // Termos Médicos Veterinários
  "Anamnese", "diagnóstico", "prognóstico", "sintomatologia", "Ausculta cardiopulmonar", "palpação abdominal", "inspeção visual",
  // Patologias
  "dermatite", "cistite", "gastrite", "otite", "conjuntivite",
  // Doenças
  "Dirofilariose", "Sarna", "FIV", "Herpesvírus felino", "Osteoartrite", "Doença de Cushing", "Dermatite atópica",
];

// Contexto base para transcrição
export const SONIOX_BASE_CONTEXT = `Este é um sistema de transcrição configurado para capturar consultas veterinárias em português brasileiro.
Campos da consulta: Motivo da consulta (queixa principal), Anamnese (histórico clínico e comportamental), Exame físico (inspeção, palpação, ausculta), Diagnóstico (suspeita clínica ou diagnóstico definitivo), Tratamento (prescrição medicamentosa e orientações).
Espécies animais: Cães, gatos.
Idioma: Português (Brasil).
Domínio: Médico/Veterinário.`;

/**
 * Constrói contexto dinâmico para SONIOX com informações específicas da consulta
 */
export function buildSonioxContext(metadata: Record<string, unknown>): string {
  const contextParts: string[] = [SONIOX_BASE_CONTEXT];

  if (metadata.pet_name) {
    contextParts.push(`Nome do paciente: ${metadata.pet_name}.`);
  }

  if (metadata.vet_name) {
    contextParts.push(`Nome do médico veterinário: ${metadata.vet_name}.`);
  }

  if (metadata.owner_name) {
    contextParts.push(`Nome do responsável: ${metadata.owner_name}.`);
  }

  contextParts.push("Esta é uma consulta veterinária.");

  return contextParts.join(" ");
}

export const DRAWER_HIDE_DELAY = 250; // milliseconds

export const TRANSCRIPT_SYNC_INTERVAL_MS = 5_000; // persistencia continua do transcript
export const AI_PROCESSING_TIMEOUT_MS = 90_000; // teto do processamento por IA no cliente
export const FINALIZE_WATCHDOG_MS = 5_000; // espera maxima pelo onFinished do Soniox
export const SILENT_RECONNECT_ATTEMPTS = 2; // tentativas antes de mostrar o banner
export const MAX_AUTO_RECONNECT_ATTEMPTS = 8; // teto de tentativas automaticas; depois so manual (botao no banner)
export const CONNECTION_PROBE_INTERVAL_MS = 2_000; // sondagem ativa da saude da conexao durante a captura
export const SONIOX_CONNECT_TIMEOUT_MS = 10_000; // teto por tentativa de handshake; sem isso um travamento fica pendurado para sempre
export const TRANSCRIPT_SYNC_BACKOFF_MS = [5_000, 10_000, 20_000, 30_000] as const;


